import { allowedLastCharacterNumberOrLetter, notAllowedCharactersFromTo } from 'forms/validationFunctions/custom';

import createValidationFn from '@gef-ui/form-core/validations/createValidationFn';
import { getLabelMessage } from '@gef-ui/localization/messages';

import isValidBusinessCaseNumber from 'utils/isValidBusinessCaseNumber';

import { businessCaseLastCharacter, regexNumber } from '../constants';
import { isLength } from './common';

const length = isLength({
	length: 16,
	lengthMessageKey: 'validation:lengthExact',
});

const firstToFifteenthCharIsNumber = notAllowedCharactersFromTo({
	msg: getLabelMessage('validation:allowedCharactersBusinessCase'),
	reg: regexNumber,
	from: 1,
	to: 15,
});

const lastCharIsNumberOrLetter = allowedLastCharacterNumberOrLetter({
	msg: getLabelMessage('validation:allowedCharactersBusinessCase'),
	reg: regexNumber,
	allowedCharacters: businessCaseLastCharacter,
	lastNum: 16,
});

const checkBusinessCaseNoValid = (fieldValue) =>
	!isValidBusinessCaseNumber(fieldValue) ? getLabelMessage('validation:allowedCharactersBusinessCase') : false;

export default createValidationFn(() => (args) => {
	const { fieldValue } = args;
	if (!fieldValue) {
		return null;
	}

	return (
		length.validate(args)?.errorMessage ||
		firstToFifteenthCharIsNumber({ fieldValue }) ||
		lastCharIsNumberOrLetter({ fieldValue }) ||
		checkBusinessCaseNoValid(fieldValue)
	);
});
